import WeeklyCalendar from "./WeeklyCalendar";
import { OccupiedBlock, Schedule } from "./types";

interface WeeklyCalendarEmpleoProps {
  forceMobile?: boolean;
  value: Schedule;
  onChange: (schedule: Schedule) => void;
  occupiedBlocks?: OccupiedBlock[];
}

/**
 * Calendario semanal con la configuración estándar de Empleo.
 * Fija el comportamiento usado en /empleo/calendario para reutilizarlo
 * en toda la app de Empleo con la misma configuración.
 */
const WeeklyCalendarEmpleo = ({
  forceMobile = false,
  value,
  onChange,
  occupiedBlocks,
}: WeeklyCalendarEmpleoProps) => (
  <WeeklyCalendar
    forceMobile={forceMobile}
    editEventsInModal
    confirmDeleteEvent
    clickableDayHeader
    showEmptyHint
    showCopyPreviousDay
    weekdaysEnabled
    weekendEnabled
    showSun
    showMoon
    fontScale={1.5}
    startTime="09:00"
    endTime="21:00"
    value={value}
    onChange={onChange}
    occupiedBlocks={occupiedBlocks}
  />
);

export default WeeklyCalendarEmpleo;
